import { Navigate, useLocation } from "react-router-dom";
import { getBearerToken, getRpcToken, clearAuthData } from "../api/apiService";

const ProtectedRoute = ({ isAuthenticated, redirectPath = "/", children }) => {
    const location = useLocation();

    const bearerToken = getBearerToken();
    const rpcToken = getRpcToken();

    if (!isAuthenticated || !bearerToken || !rpcToken) {
        clearAuthData();
        return <Navigate to={redirectPath} replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;